module.exports = __webpack_public_path__ + "img/holiday-parking.d3032c03.png";